import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import MoneyInput from 'components/Inputs/MoneyInput'
import EditBillModal from 'pages/Modals/EditBillModal'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import earningAndExpenseValidator from 'validators/earningAndExpenseValidator'
import { FaEdit, FaEye, FaTimes, FaSave, FaTrash } from 'react-icons/fa'
import { Formik } from 'formik'
import { DateTime } from 'luxon'

import {
  Container,
  FormField,
  Row,
  Input,
  InfoText,
  MoneyTextMask,
  Button,
  WarningText
} from './styles'

export default function CustomerCredit ({
  data: credit,
  onEdit: handleEdit = () => {},
  onDelete: handleDelete = () => {},
  onCloseBill: handleCloseBill = () => {}
}) {
  const [editting, setEditting] = useState (false)
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const [showEditBillModal, setShowEditBillModal] = useState (false)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const url = `/businesses/${businessId}/${credit.type === 'credit' ? 'credits' : 'debts'}/${credit.id}`
  const { bill } = credit

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const deleteCredit = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (url, requestConfig)
      setDeleting (false)
      handleDelete (credit)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleEditting = () => setEditting (!editting)
  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)
  const toggleEditBillModal = () => setShowEditBillModal (!showEditBillModal)

  if (editting) return (
    <Formik
      validationSchema={earningAndExpenseValidator}
      initialValues={{
        'description': credit.description,
        'value': Math.abs (credit.value)
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          const { data: editedCredit } = await cutileiApi.put (url, values, requestConfig)

          setSubmitting (false)
          setEditting (false)
          handleEdit ({
            ...editedCredit,
            value: editedCredit.value * (credit.type === 'credit' ? 1 : -1),
            type: credit.type
          })
        } catch (error) {
          setSubmitting (false)
          logApiError (error)
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleChange,
        handleBlur, 
        handleSubmit
      }) => (
        <Container editting={editting}>
          <InfoText>
            {DateTime.fromISO (credit.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')}
          </InfoText>
          <FormField>
            <Input
              type='text'
              name='description'
              placeholder='Descrição'
              value={values.description}
              onChange={handleChange ('description')}
              onBlur={handleBlur ('description')}
              style={{width: '100%'}}
            />
            {touched.description && errors.description && (
              <WarningText>
                {errors.description}
              </WarningText>
            )}
          </FormField>
          <FormField>
            <MoneyInput
              name='value'
              placeholder='Valor'
              value={values.value}
              onValueChange={setFieldValue}
              onBlur={handleBlur ('value')}
              style={{width: '100%'}}
            />
            {touched.value && errors.value && (
              <WarningText>
                {errors.value}
              </WarningText>
            )}
          </FormField>
          <Row>
            <Button type='button' onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? (
                <ButtonLoading style={{margin: 0}}/>
              ) : (
                <FaSave color='#35A7FF' size={16}/>
              )}
            </Button>
            <Button type='button' onClick={toggleEditting}>
              <FaTimes color='#FF3939' size={18}/>
            </Button>
          </Row>
        </Container>
      )}
    </Formik>
  )
  
  return (
    <Container editting={editting}>
      <InfoText>
        {DateTime.fromISO (credit.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')}
      </InfoText>
      <InfoText>
        {credit.description}
      </InfoText>
      <MoneyTextMask value={credit.value} style={{justifySelf: 'center'}}/>
      {bill && credit.bill_id ? (
        <Button onClick={toggleEditBillModal}>
          <FaEye color='#35A7FF' size={18}/>
        </Button>
      ) : (
        <Row>
          {AuthService.hasPermission ('customers', 'edit') && (
            <Button onClick={toggleEditting}>
              <FaEdit color='#35A7FF' size={18}/>
            </Button>
          )}
          {AuthService.hasPermission ('customers', 'delete') && (
            <Button onClick={toggleAlertDialog}>
              {deleting ? (
                <ButtonLoading style={{margin: 0}}/>
              ) : (
                <FaTrash color='#FF3939' size={16}/>
              )}
            </Button>
          )}
        </Row>
      )}
      {bill && (
        <EditBillModal
          visible={showEditBillModal}
          data={bill}
          onClose={toggleEditBillModal}
          onCloseBill={handleCloseBill}
        />
      )}
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message={
          `Deseja realmente excluir ${credit.type === 'credit' ? 'este crédito' : 'esta dívida'}?`
        }
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteCredit}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
